import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'sbc-exhibitors-video-popup',
  template: `
    <div *ngIf="data" class="sbc-exhibitors-video-popup">
      <div mat-dialog-title class="sbc-exhibitors-video-popup__heading">
        <span>{{ data.title }}</span>
        <mat-icon aria-hidden="false" aria-label="close icon" (click)="onClose()">close</mat-icon>
      </div>
      <div class="video-container"[innerHTML]="data.iframe"></div>
    </div>
  `,
  styles: [`
    mat-dialog-container {
      position: relative;
    }
    .sbc-exhibitors-video-popup mat-icon {
      cursor: pointer;
    }
    .sbc-exhibitors-video-popup__heading {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .sbc-exhibitors-video-popup iframe {
      width: 100%;
    }
    .video-container {
      position: relative;
      padding-bottom: 56.25%; /* 16:9 */
      height: 0;
    }
    .video-container iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  `],
  encapsulation: ViewEncapsulation.None,
})
export class VideoPopupComponent {
  constructor(
    public dialogRef: MatDialogRef<VideoPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VideoPopupData,
  ) { }

  onClose() {
    this.dialogRef.close();
  }
}
